import Vue from 'vue';

import { BannerInterface, MappedBanners } from '@/interfaces/BannerInterface';
import axiosInstance from '@/services/axios';
import apiUrls from '@/shared/api-urls';
import { BannerType } from '@/shared/enums/BannerType';
import { urlWithParams } from '@/shared/helpers';

const state = Vue.observable({
	isLoaded: false,
	isLoadedOffer: false,
	isPending: false,
	isPendingOffer: false,
	isPendingPromo: false,
	isPendingHBO: false,
});

export default {
	state,
	getBanners(banners: BannerType[], skipLoader = false): Promise<MappedBanners> {
		this.state.isPending = true;

		return axiosInstance
			.post<BannerInterface[]>(apiUrls.banners.url, banners, { params: { skipLoader } })
			.then(response => {
				const result: MappedBanners = {};

				response.data.forEach((banner: BannerInterface) => result[banner.alias] = banner);
				this.state.isPending = false;
				this.state.isLoaded = true;

				return result as MappedBanners;
			});
	},
	getPersonalOfferBanner(subscriberIdentity: string, serviceType: string): Promise<BannerInterface> {
		const url = urlWithParams(apiUrls.personalOfferBanner.url, { subscriberIdentity, serviceType });

		this.state.isPendingOffer = true;

		return axiosInstance
			.get(url, { params: { skipLoader: true } })
			.then(({ data }) => {
				this.state.isPendingOffer = false;
				this.state.isLoadedOffer = true;

				return data || {} as BannerInterface;
			});
	},
	getTvPromoBanner(subscriberIdentity: string): Promise<BannerInterface> {
		const url = urlWithParams(apiUrls.getTvPromoBanner.url, { subscriberIdentity });

		this.state.isPendingPromo = true;

		return axiosInstance
			.get(url)
			.then(({ data }) => {
				this.state.isPendingPromo = false;

				return data || {} as BannerInterface;
			});
	},
	getLoginBanner(): Promise<BannerInterface> {
		return axiosInstance.get(apiUrls.loginBanner.url)
			.then(({ data }) => data);
	},
	getHBOBanner(subscriberIdentity: string): Promise<BannerInterface> {
		return axiosInstance
			.get(urlWithParams(apiUrls.getHBOBanner.url, { subscriberIdentity }))
			.then(({ data }) => {
				this.state.isPendingHBO = true;

				return data || {} as BannerInterface;
			});
	},
	get isPending(): boolean {
		return this.state.isPending;
	},
	get isPendingOffer(): boolean {
		return this.state.isPendingOffer;
	},
	get isPendingPromo(): boolean {
		return this.state.isPendingPromo;
	},
	get isPendingHBO(): boolean {
		return this.state.isPendingHBO;
	},
	get isLoaded(): boolean {
		return this.state.isLoaded;
	},
	get isLoadedOffer(): boolean {
		return this.state.isLoadedOffer;
	},
};
